define('helperEntity',['require','helperEntity-isContentPage','helperEntity-isInPageRange','helperEntity-isParentQuizTaskPage','helperEntity-isQuizGamePage','helperEntity-isQuizPage','helperEntity-isQuizTaskPage','helperEntity-isTaskInScore','helperEntity-isTaskPage'],function(require) {
    'use strict';

    var Entity = {
        isContentPage: require('helperEntity-isContentPage'),
        isInPageRange: require('helperEntity-isInPageRange'),
        isParentQuizTaskPage: require('helperEntity-isParentQuizTaskPage'),
        isQuizGamePage: require('helperEntity-isQuizGamePage'),
        isQuizPage: require('helperEntity-isQuizPage'),
        isQuizTaskPage: require('helperEntity-isQuizTaskPage'),
        isTaskInScore: require('helperEntity-isTaskInScore'),
        isTaskPage: require('helperEntity-isTaskPage')
    };

    return Entity;

});

